// Central sponsor configuration. Edit/add new sponsors here as you sign them.

export const SPONSORS = [
  // ============= DREAMS LEAGUE =============
  {
    id: 'pkl-go',
    name: 'PKL Go',
    tagline: 'Play. Earn. Connect.',
    body: "The pickleball community app — track matches, climb the ELO ladder, and earn rewards every time you play.",
    ctaLabel: 'Download the App',
    url: 'https://www.pklgo.com/',
    logo: 'https://static.wixstatic.com/media/0c587d_0fb24a99aa154574a5e7ded48ddc4a5a~mv2.png',
    accentFrom: '#FFD60A',
    accentTo: '#FFC300',
    textColor: '#000000',
    eyebrowColor: '#1a1a1a',
    ctaBg: '#000000',
    ctaText: '#ffffff',
    logoFilter: 'none',
    slots: [{ channel: 'dreams_league', slotId: '1' }],
  },
  {
    id: 'seeq',
    name: 'SEEQ Clear Protein',
    tagline: 'Juicy. Clear. Protein.',
    body: '22g protein, zero sugar, zero lactose. Blue Razz Freeze tastes like a snow cone — hits like a real workout.',
    ctaLabel: 'Shop SEEQ',
    url: 'https://seeqsupply.com/products/blue-razz-freeze-clear-protein',
    logo: null,
    productImage: 'https://seeqsupply.com/cdn/shop/files/clear-protein-blue-razz-freeze-9929288.png?format=webp&v=1769874667&width=600',
    accentFrom: '#0EA5E9',
    accentTo: '#0369A1',
    textColor: '#ffffff',
    eyebrowColor: '#bae6fd',
    ctaBg: '#ffffff',
    ctaText: '#0369A1',
    slots: [{ channel: 'dreams_league', slotId: '2' }],
  },

  // ============= FLYT =============
  {
    id: 'the-good-internet',
    name: 'The Good Internet',
    tagline: 'The good corner of the web',
    body: 'A network of companies built to help creators win — strategy, ops, and the back office, all in one place.',
    ctaLabel: 'Enter the Network',
    url: 'https://www.thegoodinternet.com/',
    logo: 'https://framerusercontent.com/images/rk2P049nLxgQaNeSC56yNQdx4.png',
    // Retro 8-bit blue gaming vibe
    accentFrom: '#1E3A8A',
    accentTo: '#0B1F66',
    textColor: '#ffffff',
    eyebrowColor: '#93C5FD',
    ctaBg: '#FBBF24',
    ctaText: '#0B1F66',
    logoFilter: 'brightness(0) invert(1)',
    retroPixelGrid: true, // enables 8-bit grid overlay
    slots: [{ channel: 'flyt', slotId: '1' }],
  },
  {
    id: 'boring-stuff',
    name: 'Boring Stuff',
    tagline: 'We handle your BS.',
    body: 'Taxes, bookkeeping, payroll, and more — for creators. Focus on your passion, not your paperwork.',
    ctaLabel: 'Free Consultation',
    url: 'https://www.boring-stuff.com/',
    logo: 'https://framerusercontent.com/images/AAEUufeQzctploYTioZ96x4i1wY.png',
    // Founder photo on the left side of the banner
    sideImage: 'https://framerusercontent.com/images/ZEYYTAfK1gOxKZ874XB6WDiunk.png?width=400',
    sideImageAlt: 'Jon Yousef',
    sideImageCaption: 'Jon Yousef',
    // Mint green + black
    accentFrom: '#86EFAC',
    accentTo: '#22C55E',
    textColor: '#0a1a0e',
    eyebrowColor: '#14532d',
    ctaBg: '#000000',
    ctaText: '#86EFAC',
    logoFilter: 'brightness(0)',
    slots: [{ channel: 'flyt', slotId: '2' }],
  },
];

export const findSponsor = (channel, slotId) => {
  for (const s of SPONSORS) {
    if (s.slots.some(slot =>
      (slot.channel === channel || slot.channel === 'all') && slot.slotId === slotId
    )) {
      return s;
    }
  }
  return null;
};

